module.exports = __webpack_public_path__ + "images/avatars/male/7.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/7.svg
// module id = zJEW
// module chunks = 51